import { createSelectorCreator } from 'reselect';
import memoize from 'lodash/memoize';
import { GUIDE_LIST_ITEM_KIND } from '../constants';

const isCategory = ({ kind } = {}) => kind === GUIDE_LIST_ITEM_KIND.CATEGORY;
const guideListPropSelector = (state) => state.guide.list;
const guideSelectedIndexSelector = (state) => state.guide.selectedIndex;
const lockSelectedAtIndexSelector = (_, props) => props.lockSelectedAtIndex;
const listItemCountSelector = (_, props) => props.listItemCount;
const skipCategoryOnFirstRowSelector = (_, props) => props.skipCategoryOnFirstRow || true;

const hashFn = (...args) => args.reduce((acc, val) => `${acc}-${JSON.stringify(val)}`, '');
const customSelectorCreator = createSelectorCreator(memoize, hashFn);

export const guideSelectedIndexBoundariesSelector = customSelectorCreator(
  [
    guideListPropSelector,
    guideSelectedIndexSelector,
    lockSelectedAtIndexSelector,
    listItemCountSelector,
    skipCategoryOnFirstRowSelector,
  ],
  (list, selectedIndex, lockSelectedAtIndex, listItemCount, skipCategoryOnFirstRow) => {
    let startIndex = selectedIndex - lockSelectedAtIndex;
    if (isCategory(list[startIndex]) && skipCategoryOnFirstRow) {
      startIndex += 1;
    }
    const endIndex = startIndex + listItemCount;

    return { startIndex, endIndex };
  },
);
